import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import Routes from './components/Routes';
import './index.css';
import './App.css';

document.addEventListener("contextmenu", (e) => e.preventDefault());
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={Routes} />);